import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    main: {
      "& .shipeezi-new-grid-component": {
        "& > :nth-child(1)": {
          "& > :nth-child(1)": {
            width: "unset",
          },
        },
      },
    },
    iconButton: {
      padding: "5px",
      margin: "10px 0",
    },
  })
);

export default useStyles;
